/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 連携先種別
 */
export type BaseInfoCollaborationEnum =
  (typeof BaseInfoCollaborationEnum)[keyof typeof BaseInfoCollaborationEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoCollaborationEnum = {
  OTHER_EMS_TEAM: 'OTHER_EMS_TEAM',
  FIREFIGHTING_TEAM: 'FIREFIGHTING_TEAM',
  RESCUE_TEAM: 'RESCUE_TEAM',
  DR_CAR: 'DR_CAR',
  DR_HELI: 'DR_HELI',
  DISASTER_DR_HELI: 'DISASTER_DR_HELI',
  OTHER: 'OTHER',
} as const;
